export function onError(payload) {
  // Certain errors we want to ignore
  const ignoreRules = [
    /401 Unauthorized/,
    /409 Conflict/,
    // For validation errors
    /\/api\/v4\/accounts\/validate/,
    /\/api\/v4\/accounts\/signup\/validate/,
    /\/api\/v4\/accounts\/subdomains\/validate/,
    /\/api\/v4\/users\/validate/,
    // Error thrown by Google recaptcha, when human verification is needed
    /HumanVerificationRequired/,
    // Messages sent by trackers used by wallpapers
    /UnableToParseMessage: MSFAPI/,
    /EmptyWallpaperCommand:.+nuanria_messaging/,
    // Error caused by an app called VidMate https://9apps.xyz/vidmate-app-download
    /vid_mate_check/,
    // Methods not implemented by browsers. Looking at you IE.
    /Not implemented/,
    /Non implémenté/,
    // The same-origin policy restricts how a document or script loaded from one origin
    // can interact with a resource from another origin. This browser policy
    // aims to prevent information leaking between domains
    // that could allow Cross-Site Request Forgery attacks.
    // Whenever an error is emitted from another origin,
    // the error will be recorded as simply Script Error
    // with no mention of the original message.
    /Script error/,
    // This is a validation error when the user tries to upload files
    // that are bigger that the transfer size limit.
    /TooManyBytes/,
  ];

  // `payload` is the actual JSON data that will get sent to trackJS
  if (ignoreRules.some((rule) => rule.test(payload.message))) {
    return false;
  }

  // We don't want to send all our data to trackJS.
  const obscureRules = [
    {
      // Transfer id
      re: new RegExp(/\/(\w{5})\w{10,24}(\d{14,17})\//g),
      replace: '/$1[XFER-ID]$2/',
    },
    {
      // Email addresses
      re: new RegExp(/[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,4})/g),
      replace: '[EMAIL]@[DOMAIN]$1',
    },
  ];

  payload.console = JSON.stringify(payload.console);
  payload.nav = JSON.stringify(payload.nav);
  payload.network = JSON.stringify(payload.network);

  obscureRules.forEach(({ re, replace }) => {
    payload.console = payload.console.replace(re, replace);
    payload.nav = payload.nav.replace(re, replace);
    payload.network = payload.network.replace(re, replace);
    payload.url = payload.url.replace(re, replace);
  });

  payload.console = JSON.parse(payload.console);
  payload.nav = JSON.parse(payload.nav);
  payload.network = JSON.parse(payload.network);

  return true;
}

export function init(TrackJS) {
  if (!window.__trackjs__) {
    return;
  }

  // For what percentage of the users do we want to track errors?
  const enabledPercentage = __DEV__ === true ? 1 : 0.1;

  // Extract root domain without extension or subdomain. eg. wtd05, lvh, wetransferbeta
  const domainName = location.hostname.split('.').slice(-2)[0];
  const applicationName = `frontend-${domainName}`;

  TrackJS.install({
    token: window.__trackjs__.token,
    application: applicationName,
    version:
      window && window.__app_settings__ && window.__app_settings__.revision
        ? window.__app_settings__.revision
        : 'unknown',
    enabled: window.__trackjs__.enabled && Math.random() < enabledPercentage,
    onError: onError,
  });

  window['__trackjs__'] = undefined;
}
